import useCriticalAssets from '../../../hooks/useCriticalAssets';

const useNodeCriticalAsset = (nodeId: string) => {
  const { criticalAssetsData, setIsCriticalAssets, hasSetPermissions } =
    useCriticalAssets({
      isCritical: true,
    });
  const isCriticalAsset = !!criticalAssetsData.data?.find(
    (asset) => asset.id === nodeId,
  );

  const toggleCriticalAsset = () => {
    setIsCriticalAssets.setIsCriticalAssetsMutation({
      assetsIds: [nodeId],
      isCriticalValue: !isCriticalAsset,
    });
  };

  return { isCriticalAsset, toggleCriticalAsset, hasSetPermissions };
};

export default useNodeCriticalAsset;
